import { render } from "./Header.vue?vue&type=template&id=afd04a0a"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=afd04a0a&lang=css"

import exportComponent from "/home/devops/vsts-agent/_work/20/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__